import { Dispatch, SetStateAction, useEffect, useRef, useState } from 'react';

import { useTranslation } from 'react-i18next';
import { H3, H4 } from '../../styles/FontStyles';
import {
  ArrowChevron,
  Button,
  Collapsable,
  Flexed
} from '../../styles/GlobalComponents';

import { CaptionText, P1, P3 } from '../../styles/FontStyles';

import { color } from '../../styles/GlobalStyles';
import {
  Icon,
  IconFlipme,
  IconPortfolioDiamond,
  IconPortfolioOrders,
  IconPortfolioRevenue
} from '../../styles/Icons';
import { BoxPortfolio, SummaryGrid } from './Portfolio.styled';

import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import { useAppSelector } from '../../app/hooks';
import { formatUSD, walletsNFTWithdraw } from '../../helpers/helperFunctions';
import { BIG_WHALE } from '../../routes/routes';
import { getFlipMeCards, getMyHubsPayment } from './Portfolio.actions';
import { PortfolioGamingItem } from './PortfolioGamingItem';
import { WithdrawStepsEnum } from './WithdrawHubs/types';
import { WithdrawHubs } from './WithdrawHubs/WithdrawHubs';
import { UserPackage } from './Portfolio.types';

interface PaymentHubProps {
  setWithdrawStep: Dispatch<SetStateAction<WithdrawStepsEnum>>;
  withdrawStep: WithdrawStepsEnum;
  setIsOpen: any;
  transferAssetStatus: boolean;
}

export const PaymentHubSummary = ({
  setWithdrawStep,
  withdrawStep,
  setIsOpen,
  transferAssetStatus
}: PaymentHubProps) => {
  const dispatch = useDispatch();

  const [expandedFlipme, setExpandedFlipme] = useState(true);
  const [expandedPayment, setExpandedPayment] = useState(false);
  const [withdrawModal, setWithdrawModal] = useState(false);
  const [packageItem, setPackageItem] = useState<UserPackage | null>(null);
  const [selectedNFTWallet, setSelectedNFTWallet] = useState<any>(
    walletsNFTWithdraw[0]
  );

  const ref = useRef<any>(null);
  const refPayment = useRef<any>(null);

  const history = useHistory();

  const { t } = useTranslation('my_hubs');

  const { payment, flipMe } = useAppSelector((state) => state.portfolio);
  const { isCanadaRestrictedUser, isJapanRestrictedUser } = useAppSelector(
    (state) => state.auth.userInfo
  );

  useEffect(() => {
    dispatch(getMyHubsPayment());
    dispatch(getFlipMeCards());
  }, [dispatch]);

  const [height, setHeight] = useState(ref?.current?.clientHeight);
  const [heightPayment, setHeightPayment] = useState(
    refPayment?.current?.clientHeight
  );

  useEffect(() => {
    setHeight(ref?.current?.clientHeight);
    setHeightPayment(refPayment?.current?.clientHeight);
  }, [flipMe, payment]);

  return (
    <>
      <div style={{ marginBottom: 40 }}>
        <Flexed mb='20' center between>
          <H3>My FlipMe Summary</H3>
        </Flexed>

        <SummaryGrid>
          <BoxPortfolio>
            <Icon mr='16' mrSM='8' color={color.colors.secondary100}>
              <IconPortfolioOrders />
            </Icon>
            <div>
              <CaptionText caps bold color={color.colors.neutral500} mb='10'>
                Total FLIPME orders
              </CaptionText>

              <P1 bold flex alignEnd gap='5px'>
                {formatUSD(flipMe?.summary?.totalOrderAmount)}
                <P3 mb='1'>USDT</P3>
              </P1>
            </div>
          </BoxPortfolio>
        </SummaryGrid>

        <Flexed center between wrap>
          <Flexed
            mb='20'
            center
            gap='20px'
            pointer
            onClick={() => setExpandedFlipme(!expandedFlipme)}>
            <H4>My FlipMe Cards</H4>
            <ArrowChevron direction={expandedFlipme ? 'up' : 'down'} />
          </Flexed>
          {/* <Button
            negative
            maxWidth='350px'
            maxWidthSM='100%'
            onClick={() => history.push(FLIPME_CARDS)}>
            ADD FLIPME CARD
          </Button> */}
        </Flexed>

        <Collapsable expanded={expandedFlipme} elementHeight={height}>
          <div ref={ref}>
            {flipMe?.userPackages?.map((item: any, i: number) => {
              return (
                <PortfolioGamingItem
                  key={i}
                  item={item}
                  withdrawModal={withdrawModal}
                  setWithdrawModal={setWithdrawModal}
                  setSelectedNFTWallet={setSelectedNFTWallet}
                  setPackageItem={setPackageItem}
                  setIsOpen={setIsOpen}
                  transferAssetStatus={transferAssetStatus}
                  isFlipme={true}
                />
              );
            })}
          </div>
        </Collapsable>
      </div>
      <div style={{ marginBottom: 40 }}>
        <Flexed mb='20' center between>
          <H3>{t('my_payment_hub_nfts_summary')}</H3>
        </Flexed>

        <SummaryGrid>
          <BoxPortfolio>
            <Icon mr='16' mrSM='8' color={color.colors.secondary100}>
              <IconPortfolioOrders />
            </Icon>
            <div>
              <CaptionText caps bold color={color.colors.neutral500} mb='10'>
                {t('total_payment_hub_nft_orders')}
              </CaptionText>

              <P1 bold flex alignEnd gap='5px'>
                {formatUSD(payment?.summary?.totalOrderAmount)}
                <P3 mb='1'>USDT</P3>
              </P1>
            </div>
          </BoxPortfolio>

          <BoxPortfolio>
            <Icon mr='16' mrSM='8' color={color.colors.secondary100}>
              <IconPortfolioRevenue />
            </Icon>
            <div>
              <CaptionText caps bold color={color.colors.neutral500} mb='10'>
                {t('revenue_share_points')}
              </CaptionText>
              <P1 bold flex alignEnd gap='5px'>
                {formatUSD(payment?.summary?.totalRsp)} <P3 mb='1'>RSP</P3>
              </P1>
            </div>
          </BoxPortfolio>

          <BoxPortfolio>
            <Icon mr='16' mrSM='8' color={color.colors.secondary100}>
              <IconPortfolioDiamond />
            </Icon>
            <div>
              <CaptionText caps bold color={color.colors.neutral500} mb='10'>
                {t('total_orders_with_autostake_on')}
              </CaptionText>
              <P1 bold flex alignEnd gap='5px'>
                <P1 bold flex alignEnd gap='5px'>
                  {formatUSD(payment?.summary?.totalUsdAmount)}
                  <P3 mb='1'>USDT</P3>
                </P1>
              </P1>
            </div>
          </BoxPortfolio>
        </SummaryGrid>

        <Flexed center between wrap>
          <Flexed
            mb='20'
            center
            gap='20px'
            pointer
            onClick={() => setExpandedPayment(!expandedPayment)}>
            <H4>{t('my_payment_hub_nfts')}</H4>
            <ArrowChevron direction={expandedPayment ? 'up' : 'down'} />
          </Flexed>
          {!isCanadaRestrictedUser && (
            <Button
              negative
              maxWidth='350px'
              maxWidthSM='100%'
              onClick={() => history.push(BIG_WHALE)}>
              {t('add_payment_hub_nft')}
            </Button>
          )}
        </Flexed>

        <Collapsable expanded={expandedPayment} elementHeight={heightPayment}>
          <div ref={refPayment}>
            {payment?.userPackages?.map((item: any, i: number) => {
              return (
                <PortfolioGamingItem
                  key={i}
                  item={item}
                  withdrawModal={withdrawModal}
                  setWithdrawModal={setWithdrawModal}
                  setSelectedNFTWallet={setSelectedNFTWallet}
                  setPackageItem={setPackageItem}
                  setIsOpen={setIsOpen}
                  transferAssetStatus={transferAssetStatus}
                  isFlipme={false}
                />
              );
            })}
          </div>
        </Collapsable>
      </div>
      {packageItem && (
        <WithdrawHubs
          openModal={withdrawModal}
          setOpenModal={setWithdrawModal}
          packageId={packageItem.id}
          withdrawStep={withdrawStep}
          setWithdrawStep={setWithdrawStep}
          item={packageItem}
          selectedNFTWallet={selectedNFTWallet}
          setSelectedNFTWallet={setSelectedNFTWallet}
        />
      )}
    </>
  );
};
